'use client'
import { ReactNode, Children } from 'react'
import { useTranslation } from '../../context/ConfigContext'
import { useIsMobileOrTablet } from '../../utils/screen.utils'

type SellerPageStructureProps = { children: ReactNode[] }

const SellerPageStructure = ({ children }: SellerPageStructureProps) => {
  const t = useTranslation()
  const isTablet = useIsMobileOrTablet()

  const [filtersChild, mapChild, sellersChild] = Children.toArray(children)

  return (
    <div className='sellers-page-structure'>
      <h1 className='sellers-page-structure-title'>{t('footer-storelocator-title')}</h1>
      <div className='sellers-page-blocs'>
        <div className='sellers-page-bloc-filters'>
          {filtersChild}
          {!isTablet && sellersChild}
        </div>
        <div className='sellers-page-bloc-map'>{mapChild}</div>
        {isTablet && <div className='map-list-sellers-ctn'>{sellersChild}</div>}
      </div>
    </div>
  )
}

export default SellerPageStructure
